import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';

import SplashSlider from './SplashSlider';
import Dashboard from './Dashboard';
import MobileLogin from './MobileLogin';
import ProviderSpashScreen from './ProviderSpashScreen';
import config from './config';
import { osVersion, osName, browserVersion, browserName, mobileVendor, mobileModel, getUA } from "react-device-detect";
// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { AnimatePresence } from 'framer-motion';
import ContinuePopup from './popup/ContinuePopup';
import { askForPermissionToReceiveNotifications, onMessageListener, syncFcmTokenWithBackend } from '../push-notification';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const MyTimeLine = React.lazy(() => import('./MyTimeLine'));
const Wallet = React.lazy(() => import('./Wallet'));
const AddDetails = React.lazy(() => import('./AddDetails'));
const VoucherDetails = React.lazy(() => import('./VoucherDetails'));
const Search = React.lazy(() => import('./Search'));
const AdsMarkAsRead = React.lazy(() => import('./AdsMarkAsRead'));
const AdsMarkAsReadVoucher = React.lazy(() => import('./AdsMarkAsReadVoucher'));
const ProviderInfo = React.lazy(() => import('./ProviderInfo'));
const Offers = React.lazy(() => import('./Offers'));
const Messages = React.lazy(() => import('./Messages'));
const UpdateProfile = React.lazy(() => import('./UpdateProfile'));
const TermsAndCondition = React.lazy(() => import('./TermsAndCondition'));
const BillUpload = React.lazy(() => import('./BillUpload'));
const BankOfferDetails = React.lazy(() => import('./BankOfferDetails'));
const BuyMyCashDetails = React.lazy(() => import('./BuyMyCashDetails'));
const StartQuiz = React.lazy(() => import('./StartQuiz'));
const CategoryInfo = React.lazy(() => import('./CategoryInfo'));
const AdsMarkAsReadInStore = React.lazy(() => import('./AdsMarkAsReadRedOffer'));
const AdsMarkAsReadInstall = React.lazy(() => import('./AdsMarkAsReadInstall'));
const AdsMarkAsReadHybridGreen = React.lazy(() => import('./AdsMarkAsReadHybridGreen'));
const Help = React.lazy(() => import('./Help'));
const Support = React.lazy(() => import('./Support'));
const InstantCashHistory = React.lazy(() => import('./Wallet/_instant_cash'));
const MyCashHistory = React.lazy(() => import('./Wallet/_my_cash'));
const PendingCashHistory = React.lazy(() => import('./Wallet/_pending_cash'));

// const fpPromise = FingerprintJS.load();

class AppScreen extends Component {

    constructor() {
        super();

        localStorage.setItem('isFirstTimeAppOpen', true);
        localStorage.setItem('openMapViewPopup', true);

        var fbIsLoggedIn = false;
        var isUserStarted = false;
        var isUserLoggedIn = false;

        var fsProviderName = config.getProviderNameFromUrl();

        setTimeout(() => {
            this.initializeDeviceInfo();
        }, 5000);

        /* Ignore wait on inner page refresh */
        if (window.location.pathname.indexOf("ads-mark-as-read") > -1) {
            console.log(window.location.pathname);
            isUserStarted = true;
            fbIsLoggedIn = "true";
            isUserLoggedIn = true;
        }

        this.state = {
            fbIsProvider: fsProviderName !== "" ? true : false,
            fbIsProviderWait: true,
            fsProviderName: fsProviderName,
            fbIsProviderMiniProfile: false,
            isUserLoggedIn: isUserLoggedIn,
            fbIsUserLoggedIn: fbIsLoggedIn === "true" ? true : false,
            isUserStarted: isUserStarted,
            isPWAInstalled: false,
            openDialog: false,
            openPushDialog: false,
            installPrompt: null,
        }

        this.openDashboard = this.openDashboard.bind(this);
        this.storeDeviceType = this.storeDeviceType.bind(this);
        this.verifyingProvider = this.verifyingProvider.bind(this);
        this.storeGlobalSettingForNormalPWA = this.storeGlobalSettingForNormalPWA.bind(this);

        this.storeDeviceType();

        if (fsProviderName !== "") {
            localStorage.setItem(
                "OpenPWAUserPromo",
                fsProviderName
            );
            this.verifyingProvider();
        } else {
            this.storeGlobalSettingForNormalPWA();
        }
    }

     initializeDeviceInfo = async () => {
        try {
            const FingerprintJS = await import('@fingerprintjs/fingerprintjs');
            const fpPromise = FingerprintJS.default.load();
            config.storeDeviceInfo(fpPromise).then((fsDeviceId) => {
                const date = new Date();
                const foDeviceDetails = {
                    deviceDateTime:
                        date.getFullYear() +
                        "/" +
                        (date.getMonth() + 1) +
                        "/" +
                        date.getDate() +
                        " " +
                        date.getHours() +
                        ":" +
                        date.getMinutes() +
                        ":" +
                        date.getSeconds(),
                    manufacturer: mobileVendor + " " + mobileModel,
                    fsOs: osName + " " + osVersion,
                    fsBrowser: browserName + " " + browserVersion,
                    platformId: 3,
                    deviceId: fsDeviceId,
                    userAgent: getUA
                };
                localStorage.setItem(
                    "foDeviceDetails",
                    JSON.stringify(foDeviceDetails)
                );
            });
        } catch (err) {
            console.error(err);

            this.storeGlobalSettingForNormalPWA();
        }
    };

    storeDeviceType() {
        const ua = window.navigator.userAgent;
        const webkit = !!ua.match(/WebKit/i);
        const isIPad = !!ua.match(/iPad/i);
        const isIPhone = !!ua.match(/iPhone/i)
        const isIOS = isIPad || isIPhone;
        const isSafari = isIOS && webkit && !ua.match(/CriOS/i);
        if (isIOS) {
            localStorage.setItem('fiDeviceType', 1);
        } else {
            localStorage.setItem('fiDeviceType', 0);
        }
        // return {isIOS, isSafari};
    }

    componentDidMount() {
        /* Visit Counter */
        let visitCount = localStorage.getItem('fiAppVisitCount') || 0;
        visitCount = parseInt(visitCount) + 1;
        localStorage.setItem('fiAppVisitCount', visitCount);

        this.checkPWAInstalled();

        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        this.updatePWAStatus(mediaQuery);
        mediaQuery.addListener(this.updatePWAStatus);

        window.addEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt);


        /* PWA Install prompt logic */
        const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

        const hasAcknowledged = localStorage.getItem('PWAInstallAcknowledged') === 'true';
        if (isIOS) {
            if (isStandalone) {
                localStorage.setItem('isPWAInstalled', 'true');
                this.setState({ isPWAInstalled: true, openDialog: false });
            } else {
                if (!hasAcknowledged) {
                    // this.setState({ openDialog: true });
                    this.setState({ installPrompt: false, openDialog: true });
                } else {
                    localStorage.setItem('isPWAInstalled', 'true');
                    this.setState({ isPWAInstalled: true, openDialog: false });
                }
            }
        } else {
            window.addEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt);
        }


        /* Get Global Setting  */
        var urlInfo = config.getProviderDataFromUrl();

        // this.timeout = setTimeout(() => {
        //     this.setState({
        //         isUserStarted:true
        //     });
        // }, config.spashSliderMSecond);


        // window.addEventListener('appinstalled', function () {
        //     localStorage.setItem('isPWAInstalled', true);
        // });

        if (!localStorage.getItem('AppLabels')) {
            config.fatchAppStaticLabels();
        }

        document.addEventListener('click', this.handleMoreDetailsToggle);

        /* Firebase Push Notifications */
        let isIOSForPush = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
        let isStandaloneForPush = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

        // isStandaloneForPush = true;
        // isIOSForPush = true;
        if (isIOSForPush) {
            if ('Notification' in window && window.Notification.permission === 'default' && isStandaloneForPush) {
                const hasAskedPush = localStorage.getItem('iOSPushAsked');
                if (!hasAskedPush) {
                    this.setState({ openPushDialog: true });
                }
            } else if ('Notification' in window && window.Notification.permission === 'granted') {
                setTimeout(() => {
                    askForPermissionToReceiveNotifications();
                }, 3000);
            }
        } else {
            setTimeout(() => {
                askForPermissionToReceiveNotifications();
            }, 3000);
        }

        onMessageListener().then(payload => {
            console.log("Foreground Push Received:", payload);
            if (payload && payload.notification) {
                toast.success(<div>
                    <strong>{payload.notification.title}</strong><br/>
                    {payload.notification.body}
                </div>);
            }
        }).catch(err => console.log('FCM failed: ', err));

        // Test Toast on startup
        // toast.info("Notifications Enabled", { position: "top-right", autoClose: 2000 });

        window.addEventListener('swUpdated', this.handleSWUpdate);
    }

    componentWillUnmount() {
        window.removeEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt);
        window.removeEventListener("swUpdated", this.handleSWUpdate);
        document.removeEventListener('click', this.handleMoreDetailsToggle);
        clearTimeout(this.timeout);
        clearInterval(this.autoCloseInterval);
    }

    handleSWUpdate = (event) => {
        const registration = event.detail;
        toast.info(
            <div>
                <strong>New version available!</strong><br/>
                Click here to update the app.
            </div>,
            {
                position: "bottom-center",
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                onClick: () => {
                    if (registration && registration.waiting) {
                        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                    }
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            }
        );
    };

    handleMoreDetailsToggle = (event) => {
        var trigger = event.target.closest('.adsListContainer .singleMapCard .displayFlex');
        if (!trigger) {
            return;
        }

        var singleCardObj = trigger.closest('.singleMapCard');
        var details = singleCardObj ? singleCardObj.querySelector('.otherDetailsToggle') : null;
        if (!details) {
            return;
        }

        var isHidden = window.getComputedStyle(details).display === 'none';
        details.style.display = isHidden ? 'block' : 'none';

        var arrow = trigger.querySelector('.moreDetailsArrow span');
        if (arrow) {
            arrow.textContent = isHidden ? 'keyboard_arrow_down' : 'keyboard_arrow_right';
        }
    };
    updatePWAStatus = (event) => {
        const isStandalone = event.matches;
        this.setState({ isPWAInstalled: isStandalone });
        localStorage.setItem('isPWAInstalled', isStandalone ? 'true' : 'false');
    };

    handleBeforeInstallPrompt = (event) => {
        const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
        window.deferredPrompt = event;
        if (!isIOS) {
            event.preventDefault(); // Prevent automatic prompt
            this.setState({ installPrompt: event, openDialog: true });
        }

    };

    checkPWAInstalled = async () => {
        const mediaQuery = window.matchMedia('(display-mode: standalone)');
        let isStandalone = mediaQuery.matches ||
            window.matchMedia('(display-mode: minimal-ui)').matches ||
            document.referrer.startsWith('android-app://');

        const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
        const isInStandaloneMode = window.navigator.standalone === true;

        if (isIOS && isInStandaloneMode) {
            isStandalone = true;
        }

        if (!isStandalone && navigator.getInstalledRelatedApps) {
            try {
                const apps = await navigator.getInstalledRelatedApps();
                if (apps.length > 0) {
                    isStandalone = true;
                }
            } catch (error) {
                console.error('Error checking installed apps:', error);
            }
        }

        localStorage.setItem('isPWAInstalled', isStandalone ? 'true' : 'false');
        this.setState({
            isPWAInstalled: isStandalone,
        });
    };

    installPWA = () => {
        const { installPrompt } = this.state;
        if (installPrompt) {
            installPrompt.prompt();
            installPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    this.setState({ isPWAInstalled: true, openDialog: false });
                } else {
                    console.log("User dismissed PWA install");
                }
            });
        }
    };

    openDashboard() {
        localStorage.setItem('isUserLoggedIn', true);
        setTimeout(() => {
            syncFcmTokenWithBackend();
        }, 3000);
        this.setState({
            'isUserLoggedIn': true
        });
    }

    storeGlobalSettingForNormalPWA() {
        var formBody = { fsAction: 'getGlobalSetting' };
        config.fetchInformation(formBody).then((responseJson) => {
            localStorage.setItem('foGlobalSetting', JSON.stringify(responseJson));

            config.existingUserConnected(responseJson);
            if (responseJson.fbIsUserExist === true) {
                if(localStorage.getItem('isUserLoggedIn') == "true"){
                    localStorage.setItem('isUserLoggedIn', true);
                    syncFcmTokenWithBackend();
                    this.setState({ isUserLoggedIn: true, isUserStarted: true });
                }else{
                    this.setState({ isUserLoggedIn: false, isUserStarted: true });
                }
            } else {
                this.setState({ isUserLoggedIn: false, isUserStarted: true });
            }
        });
    }

    verifyingProvider() {
        var urlInfo = config.getProviderDataFromUrl();

        /* Provider mobile no store on storage */

        if (urlInfo.fsMobile !== "" && urlInfo.fsMobile !== undefined) {

            var fsDialCode = localStorage.getItem('fsDialCode') !== undefined ? localStorage.getItem('fsDialCode') : "";
            var fsMobile = urlInfo.fsMobile || "";
            fsDialCode = decodeURIComponent(fsDialCode);
            var fsUserContact = fsDialCode + fsMobile;
            localStorage.setItem('userPhone', fsUserContact);

            var formBody = { fsAction: 'checkIsUserExist', fsUserContact: fsUserContact };
            config.fetchInformation(formBody).then((checkExist) => {

                if (checkExist.fsStrictMessage !== "" && checkExist.fsStrictMessage !== undefined) {
                    alert(checkExist.fsStrictMessage);
                } else {
                    if (checkExist.fbIsUserExist) {
                        var formBody = { fsAction: 'getGlobalSetting', fsUserContact: fsUserContact };
                        config.fetchInformation(formBody).then((responseJson) => {
                            localStorage.setItem('foGlobalSetting', JSON.stringify(responseJson));

                            config.existingUserConnected(responseJson);

                            localStorage.setItem('isProfileUpdated', 'true');
                            localStorage.setItem('hasTermCheck', 'true');
                            localStorage.setItem('isProfileUpdated', true);
                            localStorage.setItem('fbIsMobileConnected', 'true');
                            localStorage.setItem('isShownMiniProfile', false);

                            localStorage.setItem('isUserLoggedIn', true);
                            syncFcmTokenWithBackend();
                            this.setState({ isUserLoggedIn: true, isUserStarted: true });
                        });
                    } else {
                        var foSetting = config.getProviderSetting();
                        if (foSetting.fbIsDirectRegistration === false) {
                            var formBody = { fsAction: 'getGlobalSetting' };
                            config.fetchInformation(formBody).then((responseJson) => {
                                localStorage.setItem('foGlobalSetting', JSON.stringify(responseJson));
                                localStorage.setItem('userPhone', fsUserContact);
                                localStorage.setItem('PhonePrefix', "");
                                this.setState({ isUserLoggedIn: false, 'fbIsProviderWait': false, isUserStarted: true });
                            });
                        } else {
                            var foDeviceDetails = '';
                            if (localStorage.getItem('foDeviceDetails') !== "") {
                                foDeviceDetails = localStorage.getItem('foDeviceDetails');
                            }

                            var fsGender = localStorage.getItem('fiGender') === "1" || localStorage.getItem('fiGender') === 1 ? 'female' : 'male';
                            var fiAge = localStorage.getItem('fiAge') !== undefined && localStorage.getItem('fiAge') !== null ? localStorage.getItem('fiAge') : 30;
                            var fsEmail = localStorage.getItem('fsEmail') !== undefined ? localStorage.getItem('fsEmail') : "";
                            var fsFirstName = localStorage.getItem('fsFirstName') !== undefined ? localStorage.getItem('fsFirstName') : "";
                            var fsLastName = localStorage.getItem('fsLastName') !== undefined ? localStorage.getItem('fsLastName') : "";
                            var fsCountryCode = localStorage.getItem('fsCountryCode') !== undefined ? localStorage.getItem('fsCountryCode') : "";
                            let fsShopifyUser = localStorage.getItem('fsShopifyUser');
                            var requestParams = {
                                "fsAction": "saveMiniProfile",
                                "fsFirstName": fsFirstName == null ? "" : fsFirstName,
                                "fsLastName": fsLastName == null ? "" : fsLastName,
                                "fsEmail": fsEmail == null ? "" : fsEmail,
                                "fsReferrerCode": urlInfo.fsProviderName,
                                'fsUserContact': fsUserContact,
                                "fiAge": fiAge,
                                "fsCountryCode": fsCountryCode,
                                "fsDialCode": fsDialCode,
                                "fsGender": fsGender,
                                "fsPaytmMobile": "",
                                'Device-Details': foDeviceDetails,
                                "fiEWalletId": config.getProviderSetting().fiUserWallet,
                                "fsUPILink": '',
                                "fbIsFromShopify": fsShopifyUser === true || fsShopifyUser === "true" ? "yes" : "no"
                            };

                            config.fetchInformation(requestParams).then((savedProfile) => {
                                var formBody = { fsAction: 'getGlobalSetting', fsUserContact: fsUserContact };
                                config.fetchInformation(formBody).then((responseJson) => {
                                    localStorage.setItem('foGlobalSetting', JSON.stringify(responseJson));

                                    config.existingUserConnected(responseJson);

                                    localStorage.setItem('isProfileUpdated', 'true');
                                    localStorage.setItem('hasTermCheck', 'true');
                                    localStorage.setItem('isProfileUpdated', true);
                                    localStorage.setItem('fbIsMobileConnected', 'true');
                                    localStorage.setItem('isShownMiniProfile', true);

                                    localStorage.setItem('isUserLoggedIn', true);
                                    syncFcmTokenWithBackend();
                                    this.openDashboard();
                                    this.setState({ isUserLoggedIn: true, isUserStarted: true });
                                });
                            });
                        }
                    }
                }

            });
        } else {
            var formBody = { fsAction: 'getGlobalSetting' };
            config.fetchInformation(formBody).then((responseJson) => {
                if (localStorage.getItem("isUserLoggedIn") === true || localStorage.getItem("isUserLoggedIn") === "true") {
                    this.openDashboard();
                } else {
                    localStorage.setItem('foGlobalSetting', JSON.stringify(responseJson));
                    localStorage.setItem('userPhone', "");
                    localStorage.setItem('PhonePrefix', "");
                    this.setState({ isUserLoggedIn: false, 'fbIsProviderWait': false, isUserStarted: true });
                }
            });
        }

    }

    render() {
        var NoInternet = config.getProviderSetting().fsNoInternet;
        var fcmToast = <ToastContainer />;
        var isPWAAppInstall = localStorage.getItem("isPWAInstalled") === "true";

        // console.log('this.state.isUserLoggedIn',this.state.isUserLoggedIn);
        /* Is Offline */
        if (this.state.isOnline === false) {
            return (
                <div className="spashScreen">
                    <ToastContainer />
                    <div className="whiteBg">
                        <div className="AppLoginScreen">
                            <div className="NoDataFound">
                                <img style={{ 'marginTop': '0' }} src={NoInternet} alt="No Data Found" />
                                <div>Oops!</div>
                                <div>You're offline right now. Check your internet connection.</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if (this.state.isUserLoggedIn === true) {
            if (this.state.fbIsProvider === false && this.state.isUserStarted === false) {
                return (<SplashSlider isStarted={this.isStarted} />)
            }

            // {!this.state.isPWAInstalled && this.state.openDialog && (localStorage.getItem('fsShopifyUser') === "true" || localStorage.getItem('fsShopifyUser') === true) && (
            // console.log(this.state.openDialog);
            return (
                <>
                    {!this.state.isPWAInstalled && this.state.openDialog && (localStorage.getItem('fsShopifyUser') !== "true" || parseInt(localStorage.getItem('fiAppVisitCount') || 0) >= 2) && (
                        <ContinuePopup
                            openDialog={true}
                            popupTitle={
                                /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
                                    ? "Moby Rewards WebApp"
                                    : "Save The Moby Web App"
                            }
                            popupContent={
                                /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
                                    ? 'To Revisit your Cashback & Rewards on the WebApp, Click your browser option 3 Dots > Share Icon > Scroll to & Add to Home Screen. <img style="max-width: 100%;" src="'+config.IMAGE_URL+'/images/pwa-images/other/ios-step.png">'
                                    : 'Save the App on your Home Screen to check your Cashback in your next visit.'
                            }
                            popupButtonText={
                                /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) ? "Don't Want Cashback" : "Don't Want Cashback"
                            }
                            saveAndroidAppOption={/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())?false:true}
                            handleAndroidSave={() => {
                                const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
                                const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

                                if (isIOS) {
                                    localStorage.setItem("PWAInstallAcknowledged", "true");
                                    localStorage.setItem("isPWAInstalled", "true");
                                    if (localStorage.getItem('hasSeenHomeTour') === null) {
                                        localStorage.setItem('hasSeenHomeTour', 'false');
                                    }
                                    this.setState({ isPWAInstalled: true, openDialog: false });
                                } else {
                                    if (this.state.installPrompt) {
                                        this.state.installPrompt.prompt();
                                        this.state.installPrompt.userChoice.then((choiceResult) => {
                                            if (choiceResult.outcome === "accepted") {
                                                localStorage.setItem("isPWAInstalled", "true");
                                                localStorage.setItem("PWAInstallAcknowledged", "true");
                                                if (localStorage.getItem('hasSeenHomeTour') === null) {
                                                    localStorage.setItem('hasSeenHomeTour', 'false');
                                                }
                                                this.setState({ isPWAInstalled: true, openDialog: false });
                                            } else {
                                                console.log("User dismissed the A2HS prompt");
                                            }
                                        });
                                    }
                                }
                            }}
                            handleClose={() => {
                                const isIOS = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
                                const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

                                if (isIOS) {
                                    localStorage.setItem("PWAInstallAcknowledged", "true");
                                    localStorage.setItem("isPWAInstalled", "true");
                                    if (localStorage.getItem('hasSeenHomeTour') === null) {
                                        localStorage.setItem('hasSeenHomeTour', 'false');
                                    }
                                    this.setState({ isPWAInstalled: true, openDialog: false });
                                } else {
                                    localStorage.setItem("PWAInstallAcknowledged", "true");
                                    localStorage.setItem("isPWAInstalled", "false");
                                    this.setState({ isPWAInstalled: true, openDialog: false });
                                }
                            }}
                        />
                    )
                    }
                    
                    {this.state.openPushDialog && (
                        <ContinuePopup
                            openDialog={true}
                            popupTitle="Enable Notifications"
                            popupContent="Never miss out on exclusive cashback offers and rewards. Enable notifications now!"
                            popupButtonText="Turn On Notifications"
                            handleClose={() => {
                                localStorage.setItem('iOSPushAsked', 'true');
                                this.setState({ openPushDialog: false });
                                askForPermissionToReceiveNotifications();
                            }}
                        />
                    )}

                    <Router>
                        <AnimatePresence>
                            <React.Suspense fallback={<div className="route-loading" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666', fontSize: '1.2rem', fontFamily: 'sans-serif' }}>Loading...</div>}>
                                <Switch>
                                    <Route exact path='/' component={Dashboard}></Route>
                                    <Route exact path='/map' component={Dashboard}></Route>
                                    <Route exact path='/wallet' component={Wallet}></Route>
                                    <Route exact path='/search' component={Search}></Route>
                                    <Route exact path='/messages' component={Messages}></Route>
                                    <Route exact path='/update-profile' component={UpdateProfile}></Route>
                                    <Route exact path='/my-timeline/:activityId?' component={MyTimeLine}></Route>
                                    <Route exact path='/terms-and-condition' component={TermsAndCondition}></Route>
                                    <Route exact path='/bill-upload/:adId' component={BillUpload}></Route>
                                    <Route exact path='/bank-offer-details/:adId/:locationId' component={BankOfferDetails}></Route>
                                    <Route exact path='/add-details/:adId/:locationId' component={AddDetails}></Route>
                                    <Route exact path='/voucher-details/:adId/:locationId' component={VoucherDetails}></Route>
                                    <Route exact path='/buymycash-details/:adId/:locationId' component={BuyMyCashDetails}></Route>
                                    <Route exact path='/start-quiz/:adId/:locationId' component={StartQuiz}></Route>
                                    <Route exact path='/publisher/:name/' component={ProviderInfo}></Route>
                                    <Route exact path='/category/:fiCategoryId/' component={CategoryInfo}></Route>
                                    <Route exact path='/ads-mark-as-read/:fiActivityId' component={AdsMarkAsRead}></Route>
                                    <Route exact path='/ads-mark-as-read-voucher/:fiActivityId' component={AdsMarkAsReadVoucher}></Route>
                                    <Route exact path='/ads-mark-as-read-in-store/:fiActivityId' component={AdsMarkAsReadInStore}></Route>
                                    <Route exact path='/ads-mark-as-read-hybrid/:fiActivityId' component={AdsMarkAsReadHybridGreen}></Route>
                                    <Route exact path='/ads-mark-as-install/:fiActivityId' component={AdsMarkAsReadInstall}></Route>

                                    <Route exact path='/offers' component={Offers}></Route>
                                    <Route exact path='/help' component={Help}></Route>
                                    <Route exact path='/support' component={Support}></Route>

                                    <Route exact path='/history-instant-cash' component={InstantCashHistory}></Route>
                                    <Route exact path='/history-mycash' component={MyCashHistory}></Route>
                                    <Route exact path='/history-pending-cash' component={PendingCashHistory}></Route>

                                </Switch>
                            </React.Suspense>
                        </AnimatePresence>
                    </Router>
                    {fcmToast}
                </>
            )
        } else {
            if (this.state.fbIsProvider) {
                if (this.state.fbIsProviderWait) {
                    return (
                        <ProviderSpashScreen />
                    )
                } else {
                    return (
                        <MobileLogin fbIsProvider={true} openDashboard={()=>this.openDashboard()} />
                    )
                }
            } else {
                if (this.state.isUserStarted) {
                    return (
                        <MobileLogin fbIsProvider={true} openDashboard={()=>this.openDashboard()} />
                    )
                } else {
                    return (<ProviderSpashScreen isStarted={this.isStarted} />)
                }
            }
        }
    }
}

export default AppScreen;
